import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
    DateInput
} from 'react-admin';
import { websiteStatuses } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminWebsiteEdit: () => JSX.Element = (): JSX.Element => {
    return (
        <Edit>
            <SimpleForm>
                <TextInput name="baseUrl" source="baseUrl" validate={[required()]} fullWidth />
                <SelectInput source="status" choices={ websiteStatuses } />
                <ReferenceInput
                    name="company"
                    source="company"
                    reference="companies"
                >
                    <SelectInput source="company"  optionText="name" />
                </ReferenceInput>
                {/* The verification token is held out of the API by HQAPI-99: it proves ownership
                    of a domain, DomainProvisioner generates it as a UUID and nobody types one. The
                    customer who owns the domain reads their own in the portal. The expiration below
                    stays, because CompanyDomainsPanel uses it to say what they still have to do. */}
                <DateInput source="verificationTokenExpiration" />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}